import { ItemStates } from "../../models/itemStates";
import {
    SET_CONFIGURATION,
    CONFIGURATION_LOADED,
    SET_MENU_ITEMS,
    SET_SELECTED_MENU,
    SET_SUMMARY_ITEMS,
    SET_MENU_STRUCTURE,
    SET_ITEM_STATES,
    SET_PREVIEW_ITEM,
    SET_IMAGE_URL,
} from "../actions/configurationActions";
import ConfigurationState from "../stateTypes/configurationState";

const initialState: ConfigurationState = {
    modelId: null,
    configurationString: null,
    previewConfig: null,
    selectedMenu: null,
    menuStructure: [],
    menuItems: {},
    itemMap: {},
    itemStates: new ItemStates([]),
    previewItem: null,
    summaryItems: [],
    imageUrl: null,
};

const cofigurationReducer = (state: ConfigurationState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_CONFIGURATION: {
            const newState = { ...state };
            // Set the properties that are defined in the action.
            if (action.configurationString !== undefined) {
                newState.configurationString = action.configurationString;
            }
            if (action.previewConfig !== undefined) {
                newState.previewConfig = action.previewConfig;
            }
            return newState;
        }
        case CONFIGURATION_LOADED:
            return {
                ...state,
                configurationString: action.configurationString,
                modelId: action.modelId,
                itemStates: action.itemStates,
                itemMap: action.itemMap,
            };
        case SET_SELECTED_MENU:
            return {
                ...state,
                selectedMenu: action.selectedMenu,
            };
        case SET_MENU_ITEMS:
            return {
                ...state,
                menuItems: action.menuItems,
            };
        case SET_ITEM_STATES:
            return {
                ...state,
                itemStates: action.itemStates,
            };
        case SET_PREVIEW_ITEM:
            return {
                ...state,
                previewItem: action.item,
            };
        case SET_MENU_STRUCTURE:
            return {
                ...state,
                menuStructure: action.menuStructure,
            };
        case SET_SUMMARY_ITEMS:
            return {
                ...state,
                summaryItems: action.summaryItems,
            };
        case SET_IMAGE_URL:
            return {
                ...state,
                imageUrl: action.imageUrl,
            };
        default:
            return state;
    }
};

export default cofigurationReducer;
